import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  fallback?: string;
}

const LazyImage = React.forwardRef<HTMLImageElement, LazyImageProps>(
  ({ src, alt, width, height, className, fallback, loading = 'lazy', ...props }, ref) => {
    const [hasError, setHasError] = useState(false);

    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        onError={() => setHasError(true)}
        className={cn(
          'w-full h-full object-cover',
          hasError && 'opacity-50',
          className
        )}
        style={{
          aspectRatio: width && height ? `${width}/${height}` : undefined,
          contentVisibility: 'auto'
        }}
        {...props}
      />
    );
  }
);

LazyImage.displayName = 'LazyImage';

export { LazyImage };